import { useToast } from '@chakra-ui/toast';
import { useInfiniteQuery } from 'react-query';
import { getFbFeed } from '../../../api/firebase';
import { FbFeed } from '../../../state/model/facebook';
import { PostType } from '../../../state/model/firebase';

export default function useFacebookFeed(
  enabled: boolean,
  teamId: string,
  pageId: string
) {
  const toast = useToast();
  return useInfiniteQuery(
    [pageId, 'fbfeed'],
    (context) =>
      getFbFeed(
        teamId,
        pageId,
        PostType.FacebookFeed,
        context.pageParam
      ) as Promise<FbFeed>,
    {
      enabled,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      onError: (error: Error) => {
        toast({
          description: `${error}`,
          position: 'top-right',
          duration: 9000,
          status: 'error',
          isClosable: true,
        });
      },
    }
  );
}
